import { render, staticRenderFns } from "./courseAuthorConfig.vue?vue&type=template&id=ef678b68&scoped=true&"
import script from "./courseAuthorConfig.vue?vue&type=script&lang=js&"
export * from "./courseAuthorConfig.vue?vue&type=script&lang=js&"
import style0 from "./courseAuthorConfig.vue?vue&type=style&index=0&id=ef678b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef678b68",
  null
  
)

export default component.exports